import Navbar from "../includes/navbar";

function NotFound() {
    return (
        <>
            <Navbar activePage="#" />
            <section className="not-found-page">
                <h1 className="nf-code">404</h1>
                <div className="nf-tagline">
                    <span className="tagline-line"></span>
                    <span className="tagline-text">Page not found</span>
                    <span className="tagline-line"></span>
                </div>
                <p className="nf-message">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <div className="button-container">
                    <a href="/" className="nf-btn">Back to Home</a>
                    <a href="/projects" className="nf-btn">View Projects</a>
                </div>
            </section>
        </>
    );
}

export default NotFound;
